import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { HttpClientModule } from '@angular/common/http';
import { IonicStorageModule } from '@ionic/storage';
import { FileTransfer, FileUploadOptions, FileTransferObject } from '@ionic-native/file-transfer/ngx';
import { NgxMaskIonicModule } from 'ngx-mask-ionic';
import { CountdownModule } from 'ngx-countdown';
import { GtmModule } from 'ngx-gtm';
import { AyudaComponent } from './modals/ayuda/ayuda.component';

declare global {
  interface Window {
    dataLayer: any;
  }
}


@NgModule({
  declarations: [AppComponent, AyudaComponent],
  entryComponents: [AyudaComponent],
  imports: [
    BrowserModule,
    CountdownModule,
    HttpClientModule,
    IonicModule.forRoot({
      rippleEffect: false,
      mode: 'md'
    }),
    IonicStorageModule.forRoot(),
    AppRoutingModule,
    NgxMaskIonicModule.forRoot(),
    DeviceDetectorModule.forRoot(),
    GtmModule.forRoot({
      gtmId: environment.gtagcode,
      isEnabled: true
    }),
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),

  ],
  providers: [
    StatusBar,
    SplashScreen,
    FileTransfer,
    FileTransferObject,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    //{provide: LocationStrategy, useClass: HashLocationStrategy}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
